import React from 'react';
import { useLocation } from 'react-router-dom';
import './StaticPage.css';

const StaticPage: React.FC = () => {
  const location = useLocation();
  const path = location.pathname.substring(1);
  
  const pageContent: Record<string, { title: string; content: string }> = {
    'buying-guide': {
      title: 'Buying Guide',
      content: 'Learn how to choose the right industrial supplies for your business. Our comprehensive guides cover everything from safety gear to power tools.'
    },
    'top-buying': {
      title: 'Top Buying Requirements',
      content: 'Explore the most sought-after industrial products and bulk buying requirements from our trusted B2B partners across India.'
    },
    'copyright': {
      title: 'Copyright Policy',
      content: '© 2026 Industry Bulls Lab PRIVATE LIMITED. All content, images, and brand assets are protected under copyright law.'
    },
    'privacy': {
      title: 'Privacy Policy',
      content: 'Your privacy is important to us. We collect and use your data only to provide a better shopping experience and fulfill your orders securely.'
    },
    'compliance': {
      title: 'Compliance',
      content: 'Industrybull adheres to all regulatory standards and industrial safety compliance requirements for B2B commerce in India.'
    }
  };

  const current = pageContent[path] || { title: 'Information', content: 'Details coming soon...' };

  return (
    <div className="static-page">
      <div className="static-page__container">
        <h1 className="static-page__title">{current.title}</h1>
        <div className="static-page__body">
          <p>{current.content}</p>
          <p>This page is currently being updated with more detailed information. Please check back later or contact our support team for immediate assistance.</p>
        </div>
      </div>
    </div>
  );
};

export default StaticPage;
